export default __webpack_public_path__ + "static/media/jewelry-inventory-collectibles_page.5afbdc32.pdf";